import React, {useRef, useState} from 'react';
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
import axios from "axios";

const NewsletterBlock = ({pageContext, text}) => {
    const language = pageContext?.language ?? 'en';

    const refEmail = useRef(null);
    const {executeRecaptcha} = useGoogleReCaptcha();

    const [err, setErr] = useState('');
    const [subscribed, setSubscribed] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const handleSubmit = async (e) => {
        setDisabled(true);
        e.preventDefault();
        if (!executeRecaptcha) {
            return;
        }
        let email = '';
        if (refEmail.current) {
            email = refEmail.current.value;
        }
        if (!email.match(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i)) {
            setErr('Invalid email address!');
            setDisabled(false);
        } else {
            const result = await executeRecaptcha('subscribe');
            const data = {email, token: result};
            const response = await axios.post(`${process.env.LOOPBACK_API_URL}/landing/subscribe`, data);
            if (response.data.success) {
                setSubscribed(true);
            } else {
                setErr(response.data.err);
                setDisabled(false);
            }
        }
    }
    return (
        <div className="cta-signup">
            <h2><span>Subscribe to get to know about launching our app!</span></h2>
            <div className="mailchimp-one block">
                <div className="row align-items-center">
                    <div className="col-lg-12">
                        <h3>{text}</h3>
                    </div>
                    {subscribed && (
                        <div className="col-lg-12">
                            <h4 className="text-success">You've successfully subscribed! Thank you!</h4>
                        </div>
                    )}
                    {!subscribed && (
                        <div className="col-lg-12">
                            <form id='recaptcha-form' className="mailchimp-one__form mc-form"
                                  onSubmit={handleSubmit}>
                                <div className="input">
                                    <input type="text" ref={refEmail} className={err ? 'error' : ''}
                                           placeholder="Email Address"/>
                                </div>
                                <button disabled={disabled}
                                        className={`thm-btn mailchimp-one__btn ${disabled ? 'disabled' : ''}`}
                                        type={'submit'}>Subscribe now
                                </button>
                            </form>
                            <div className="mc-form__response">{err}</div>
                        </div>)}
                </div>
            </div>
        </div>);
}

export default NewsletterBlock;
